import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CommonFunctions } from 'src/app/shared/common/common-functions';

@Component({
  templateUrl: './text-fields/text-field/text-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BaseFormComponent implements OnInit {

  @Input() formGroup?: UntypedFormGroup;
  @Input() propertyName: string;

  @Input() label?: string;
  @Input() subText?: string;
  @Input() propertyId?: string;
  @Input() tooltip?: string;
  @Input() regular?: boolean;

  isOptional: boolean;
  @Input('optional')
  set optional(value: boolean) { this.isOptional = this.coerceBooleanProperty(value); }

  isReadonly: boolean;
  @Input('readonly')
  set readonly(value: boolean) { this.isReadonly = this.coerceBooleanProperty(value); }

  // Required so text-field template compiles as this component references that instead of a dummy template
  maxLength? = 45;

  //Grid Columns
  columns? = 4;

  /** CSS styling fields */
  FIELD_SPACING = 40;
  LABEL_SPACING = 2;

  constructor(commonFunctions: CommonFunctions) { }

  ngOnInit() {
    if ( this.propertyId == null ) {
      this.propertyId = this.propertyName;
    }
    if ( this.label == null ) {
      this.FIELD_SPACING = 20;
    }
    // When we programatically set values to fields mark them as touched to trigger validation 
    try {
      if (this.formGroup && this.formGroup.controls[this.propertyName] &&
          this.formGroup.controls[this.propertyName].value && this.formGroup.controls[this.propertyName].value !== '' ) {
          setTimeout(() => {
            this.formGroup.controls[this.propertyName].markAsTouched();
          });
        }
     } catch(ex) {
       console.log('[BaseFormComponent] ngOnInit this.propertyName='+ this.propertyName +' userAction ex' + ex.message);
     } 
  }

  private coerceBooleanProperty(value: any): boolean {
    return value != null && `${value}` !== 'false';
  }

  isInvalid(): boolean {
    return this.formGroup.get(this.propertyName) != null &&
      ( this.formGroup.get(this.propertyName).touched || this.formGroup.get(this.propertyName).dirty) &&
      this.formGroup.get(this.propertyName).invalid;
  }
}
